var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogicalAssessment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2905 3.45044L10.7905 7.95044M10.7905 7.95044H13.603M10.7905 7.95044V5.13794",
    stroke: "#44546F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.29053 15.4504L7.79053 10.9504M7.79053 10.9504H4.97803M7.79053 10.9504V13.7629",
    stroke: "#44546F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.79053 9.45044C1.79053 5.91491 1.79053 4.14714 2.88888 3.04879C3.98723 1.95044 5.75499 1.95044 9.29053 1.95044C12.8261 1.95044 14.5938 1.95044 15.6922 3.04879C16.7905 4.14714 16.7905 5.91491 16.7905 9.45044C16.7905 12.986 16.7905 14.7537 15.6922 15.8521C14.5938 16.9504 12.8261 16.9504 9.29053 16.9504C5.75499 16.9504 3.98723 16.9504 2.88888 15.8521C1.79053 14.7537 1.79053 12.986 1.79053 9.45044Z",
    stroke: "#44546F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogicalAssessment);
export default __webpack_public_path__ + "static/media/Logical_Assessment.9ff077ba0afd286499a90f7d2594b695.svg";
export { ForwardRef as ReactComponent };